import $http from '@/core/services/http.service';
import { ActionTree } from 'vuex';

import { State } from '@/manager/payment/store/state';
import Endpoints from '@/constants/endpoints';
import UtilsService from '@/core/services/utils.service';

export interface Actions {
    fetchBankList: {  };
}

export const actions: ActionTree<State, any> = {
    fetchBankList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {};
            params = UtilsService.getQueryParams(payload);
            $http.get(`${Endpoints.bank}`, { params })
                .then((res) => {
                    const data = res.data;
                    commit('setBankList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
};
